const SELECTORS = [
  '.hero__title',
  '.hero__cta',
  '.about__title',
  '.about__intro',
  '.about__block',
  '.partners__title',
  '.services__title',
  '.services__card',
  '.projects__title',
  '.events__title',
  '.events__box',
  '.materials__title',
  '.materials__intro',
  '.materials__column',
  '.partnership__title',
  '.partnership__intro',
  '.partnership__box',
  '.partnership__outro',
  '.partnership__cta',
  '.contact__info',
  '.contact__form-wrap',
  '.policies__head',
  '.content > *',
  '.error-page__inner',
];

export const initScrollReveal = () => {
  const els = Array.from(document.querySelectorAll(SELECTORS.join(',')));
  if (!els.length) return;

  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  els.forEach((el) => el.classList.add('reveal'));

  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach((el) => el.classList.add('is-visible'));
    return;
  }

  els.forEach((el) => {
    const siblings = Array.from(el.parentElement.children).filter((child) =>
      child.classList.contains('reveal')
    );
    const index = siblings.indexOf(el);
    if (index > 0) {
      el.style.setProperty('--reveal-delay', `${Math.min(index, 5) * 0.08}s`);
    }
  });

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  els.forEach((el) => observer.observe(el));
};
